import DashboardLayout from './layout';

export { DashboardLayout };
export default DashboardLayout;
